import { __extends } from "tslib";
import { ASError } from '@awayfl/avm2';
var IllegalOperationError = /** @class */ (function (_super) {
    __extends(IllegalOperationError, _super);
    function IllegalOperationError(message, id) {
        if (message === void 0) { message = ''; }
        if (id === void 0) { id = 0; }
        return _super.call(this, message, id) || this;
    }
    // Called whenever the class is initialized.
    IllegalOperationError.classInitializer = null;
    // List of static symbols to link.
    IllegalOperationError.classSymbols = null; // [];
    // List of instance symbols to link.
    IllegalOperationError.instanceSymbols = null; // [];
    return IllegalOperationError;
}(ASError));
export { IllegalOperationError };
